import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "react-bootstrap";
import { convertTime, convertTo12HourFormat } from "../common-data/Converts";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import { addTimeSheet, updateTimeSheet } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import TSFormMobile from "./TSFormMobile";
import { isMobile } from "react-device-detect";

const TSForm = ({
  userInfoData,
  isEdit,
  rowData,
  closeModal,
  callFunction,
  sheetContentData,
  isClusterManager,
  sheetData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const { receptionistBySlot, loading, error } = useSelector(
    (state) => state.dropdown
  );

  const [fdShifts, setFdShifts] = useState({});
  const [shiftDetail, setShiftDetail] = useState(null);
  const [formValues, setFormValues] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null);

  // console.log("userInfoData===>>", userInfoData);

  const handleSubmit = async (status = "draft") => {
    setIsSubmit(true);

    const sheet_details = [];
    Object.values(fdShifts).forEach((shift) => {
      const startHour = parseInt(shift.start_time.split(":")[0], 10);
      const endHour = parseInt(shift.end_time.split(":")[0], 10);

      for (let hour = startHour; hour < endHour; hour++) {
        const slotStartTime = `${hour}:00`;
        const slotEndTime = `${hour + 1}:00`;

        const slotIndex = sheet_details.length;
        const description = formValues[slotIndex] ?? "";

        sheet_details.push({
          slot_start_time: slotStartTime,
          slot_end_time: slotEndTime,
          description,
        });
      }
    });

    if (status === "active") {
      const emptyDescriptions = sheet_details.some(
        (detail) => !detail.description?.trim()
      );

      if (emptyDescriptions) {
        toast.error("All fields are mandatory for final submission.");
        return;
      }
    }

    // console.log("sheet_details is==> ", sheet_details);

    const payload = {
      user_id: userInfoData?.uid || userInfoData?.user_id,
      gym_id: userInfoData?.gym_id,
      status,
      sheet_details,
    };

    const updatePayload = {
      uid: sheetData?.uid,
      ...payload,
    };

    const result = await dispatch(
      commonPostPutApi({
        method: sheetContentData?.length > 0 ? "PUT" : "POST",
        endpoint: sheetContentData?.length > 0 ? updateTimeSheet : addTimeSheet,
        payload: sheetContentData?.length > 0 ? updatePayload : payload,
        token: userInfoData?.token,
      })
    );

    if (result?.payload?.status) {
      toast.success(result?.payload?.message || "Success!");
      callFunction();
      closeModal();
    } else {
      const errorMessage = result?.error?.message || result?.payload?.message;
      toast.error(errorMessage || "Something Went Wrong!");
    }
  };

  const handleConfirm = (status) => {
    if (status === "draft") {
      handleSubmit("draft");
    } else {
      showConfirmAlert(
        () => handleSubmit("active"),
        `Are you sure, You can not edit the form after final submit!`
      );
    }
  };

  const onChangeTextInput = (content, index) => {
    setIsSubmit(false);

    setFormValues((prev) => {
      const newValues = Array.isArray(prev) ? [...prev] : [];
      newValues[index] = content || "";
      return newValues;
    });
  };

  useEffect(() => {
    if (!loading && !error && receptionistBySlot?.length > 0) {
      const data = receptionistBySlot[0]?.info;

      const shiftDetails =
        data?.shift_details?.length > 0 ? data.shift_details : null;

      if (shiftDetails) {
        setFdShifts(shiftDetails);

        const slots = ["SHIFT TIMINGS"];

        shiftDetails.forEach((shift) => {
          const startTime = parseInt(shift.start_time.split(":")[0]);
          const endTime = parseInt(shift.end_time.split(":")[0]);

          for (let i = startTime; i < endTime; i++) {
            const slotStart = convertTo12HourFormat(`${i}:00`);
            const slotEnd = convertTo12HourFormat(`${i + 1}:00`);
            slots.push(`${slotStart} - ${slotEnd}`);
          }
        });

        setShiftDetail(slots);

        // Pre-fill form values from sheetContentData if it exists
        if (sheetContentData?.length > 0) {
          const preFilledValues = [];
          sheetContentData.forEach((content) => {
            const startHour = parseInt(content.slot_start_time.split(":")[0]);
            const firstShiftStartHour = parseInt(
              shiftDetails[0].start_time.split(":")[0]
            );
            const index = startHour - firstShiftStartHour;
            preFilledValues[index] = content.description;
          });
          setFormValues(preFilledValues);
        }
      } else {
        setShiftDetail(null);
      }
    } else {
      setShiftDetail(null);
    }
  }, [loading, error, receptionistBySlot, sheetContentData]);

  return (
    <div className="createNewCTOModalContainer timesheet-container">
      <CommonHeadingNMultipleBtn
        title={`${isEdit ? "Update" : "Add New"} Sheet`}
        onClose={closeModal}
        customButtons={
          sheetData?.approval_status === 0 || !sheetData
            ? [
                {
                  variant: "primary",
                  onClick: () => handleConfirm("draft"),
                  disabled: postPutLoadingFormData,
                  label: "Save as Draft",
                },
                {
                  variant: "success",
                  onClick: () => handleConfirm("active"),
                  disabled: postPutLoadingFormData,
                  label: "Final Submit",
                },
              ]
            : []
        }
        isLoading={postPutLoadingFormData}
      />

      {!isMobile && (
        <div className="hideMobile">
          <div className="time-sheet-container">
            {shiftDetail ? (
              shiftDetail.map((shift, index) => {
                return (
                  <div className="time-sheet-box" key={index}>
                    <div className="sheet-item sheet-left">
                      <span
                        className={`sheet-time ${index === 0 ? "tb-head" : ""}`}
                      >
                        {shift || "-"}
                      </span>
                    </div>
                    <div
                      className={`sheet-item sheet-right ${
                        index === 0 ? "tb-head" : ""
                      }`}
                    >
                      {index === 0 ? (
                        <span className="shift-time-tb-head">
                          {fdShifts
                            ?.map(
                              (fd) =>
                                `${convertTime(fd.start_time)} - ${convertTime(
                                  fd.end_time
                                )} (${fd.shift_name || "-"})`
                            )
                            .join(" - ")}
                        </span>
                      ) : (
                        <form className="" style={{ width: "100%" }}>
                          <div className="formInputsGrid oneGridSystem">
                            <div className="formInputBox span4">
                              <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border ">
                                <TimeSheetEditor
                                  index={index - 1}
                                  value={formValues[index - 1]}
                                  onChange={(content) =>
                                    onChangeTextInput(content, index - 1)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <span className="info">No Shift Found!</span>
            )}
          </div>
        </div>
      )}

      {isMobile && (
        <TSFormMobile
          fdShifts={fdShifts}
          shiftDetail={shiftDetail}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
          formValues={formValues}
          onChangeTextInput={onChangeTextInput}
          isEdit={isEdit}
          sheetData={sheetData}
          userInfoData={userInfoData}
          sheetContentData={sheetContentData}
        />
      )}
    </div>
  );
};

export default TSForm;

const CommonHeadingNMultipleBtn = ({
  title,
  onClose,
  customButtons,
  isLoading,
}) => {
  return (
    <div className="modalHeadAndCloseContainer doubleBtns">
      <h2>{title}</h2>
      <div className="btnsContainer flexEnd">
        <Button variant="danger" onClick={onClose}>
          Close
        </Button>
        {customButtons?.map((button, index) => (
          <Button
            key={index}
            variant={button.variant}
            onClick={button.onClick}
            disabled={button.disabled || isLoading}
          >
            {button.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export const TimeSheetEditor = ({ index, value, onChange }) => (
  <ReactQuill
    id={`remarks-${index}`}
    name={`remarks-${index}`}
    // className={`formInput ${formErrors?.remarks ? "formError" : ""}`}
    className={`formInput`}
    placeholder="Enter Detail.."
    value={value || ""}
    onChange={onChange}
    modules={{
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
      ],
    }}
  />
);
